export default Object.freeze({
  AVAILABLE: 'AVAILABLE',
  CLOSED: 'CLOSED',
})
